import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  color: theme?.palette?.primaryDark,
  fontSize: '13px',
  lineHeight: '0.9375rem',
  fontFamily: 'Calibri'
}));
